module.exports = __webpack_public_path__ + "9ba87f8de480e96c867bd053d375a564.svg";